// store.js
import { configureStore } from '@reduxjs/toolkit'; 
import authReducer from '../features/authSlice'; 
import crimeReducer from '../features/crimeSlice'; 
import policeReducer from '../features/policeSlice'; // Import policeReducer
import personReducer from '../features/personSlice'; // Import personReducer

const store = configureStore({ 
  reducer: { 
    auth: authReducer, 
    crime: crimeReducer, 
    police: policeReducer,
    person: personReducer,
  }, 
}); 

export default store; 
